import useCreditsSubscription from '@/hooks/useCreditsSubscription';
import useCreditsInfoAnalytics from '@/hooks/useCreditsInfoAnalytics';
import { useStreakAutoOpen } from '@/features/free-pass';

/**
 * Session-level state syncs: SDK credits subscription and the balance
 * analytics riding on it. User auth is established at bootstrap (entry.tsx →
 * startAuthSync), so this hook just wires reactive sync.
 */
const useSessionBootstrap = () => {
  useCreditsSubscription();
  useCreditsInfoAnalytics();
  useStreakAutoOpen();
};

export default useSessionBootstrap;
